export var RoleSystemNameEnum;
(function (RoleSystemNameEnum) {
    RoleSystemNameEnum["Coach"] = "Coach";
    RoleSystemNameEnum["Practitioner"] = "Practitioner";
    RoleSystemNameEnum["Principal"] = "Principal";
    RoleSystemNameEnum["Child"] = "Child";
    RoleSystemNameEnum["SuperAdmin"] = "Super Admin";
    RoleSystemNameEnum["Administrator"] = "Administrator";
})(RoleSystemNameEnum || (RoleSystemNameEnum = {}));
export var RoleDefaultNameEnum;
(function (RoleDefaultNameEnum) {
    RoleDefaultNameEnum["Coach"] = "Coach";
    RoleDefaultNameEnum["Practitioner"] = "Practitioner";
    RoleDefaultNameEnum["Principal"] = "Principal";
    RoleDefaultNameEnum["Child"] = "Child";
    RoleDefaultNameEnum["SuperAdmin"] = "Super Admin";
    RoleDefaultNameEnum["Administrator"] = "Administrator";
})(RoleDefaultNameEnum || (RoleDefaultNameEnum = {}));
//# sourceMappingURL=role-system-names.js.map